//Models
PJQ.models.prequal = {};

PJQ.models.prequal.Form = PJQ.models.BaseModel.extend({
    idAttribute: 'masterUserId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'prequal'
            },
            {
                endpoint: 'form'
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.get('masterUserId') > 0 ? this.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
            }
        ]);
    },
    parse: function (model) {
        if (model && _.size(model) > 0) {
            this.tabs = {};
            this.fields = {};
            this.categories = [];
            if (model.tabs) {
                this.tabs = model.tabs;
                _.each(model.tabs, _.bind(function (tab) {
                    _.each(tab.fields, _.bind(function (field) {
                        this.fields[field.prequalFieldId] = field;
                        if (this.categories.indexOf(field.category) < 0) {
                            this.categories.push(field.category);
                        }
                    }, this));
                }, this));
            }

            if (this.preferences && model.preferences) {
                this.preferences.set(model.preferences);
            } else {
                this.preferences = new PJQ.models.preferences.Preferences(model.preferences);
            }
        }
        return model;
    }
});

PJQ.models.prequal.Prequal = PJQ.models.BaseModel.extend({
    idAttribute: 'prequalCoreId',
    endpoint: function () {
        if (this.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'prequal',
                    value: this.id
                },
                {
                    endpoint: 'data'
                }
            ], [
                {
                    parameter: 'masterUserId',
                    value: this.get('masterUserId') > 0 ? this.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
                }
            ]);
        } else if (this.contact != null && this.contact.id > 0) {
            return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.contact.id
                },
                {
                    endpoint: 'prequal'
                },
                {
                    endpoint: 'data'
                }
            ], [
                {
                    parameter: 'masterUserId',
                    value: this.get('masterUserId') > 0 ? this.get('masterUserId') : (PJQ.app.session.preferences.hasPref('portalOwner') ? PJQ.app.session.preferences.getPref('portalOwner') : PJQ.app.session.get('masterUserId'))
                }
            ]);
        }
        return null;
    },
    fetch: function (options) {
        let fnSuccess = options ? options.success : _.noop();
        PJQ.models.BaseModel.prototype.fetch.call(this, _.defaults({
            success: _.bind(function () {
                let cbArgs = arguments;
                PJQ.app.session.fetchPrequalForm(this.get('masterUserId'), _.bind(function (form) {
                    this.parseForm(form);
                    if (typeof fnSuccess === 'function') {
                        fnSuccess(...cbArgs);
                    }
                }, this));
            }, this),
            fail: options ? options.fail : _.noop()
        }, options));
    },
    addPatchValue: function (obj) {
        if (_.size(obj.attribute) === 0) {
            return;
        }

        if (this.dirtyAttributes.patchValues == null) {
            this.dirtyAttributes.patchValues = [];
        } else {
            for (let i = 0; i < _.size(this.dirtyAttributes.patchValues); i++) {
                if (this.dirtyAttributes.patchValues[i].attribute === obj.attribute) {
                    this.dirtyAttributes.patchValues[i].value = obj.value;
                    return;
                }
            }
        }
        this.dirtyAttributes.patchValues.push(obj);

        this.set('patchValues', this.dirtyAttributes.patchValues);
    },
    parseForm: function (form) {
        this.tabs = form.tabs;
        this.fields = form.fields;
        this.categories = form.categories;
        this.preferences = form.preferences;

        _.each(this.fields, function (field) {
            field.fieldValue = null;
            if (_.size(field.coreFieldName) > 0) {
                if (field.coreFieldName.indexOf('Contact.ccf_') !== -1) {
                    if (this.contact != null) {
                        let fieldId = parseInt(field.coreFieldName.replace('Contact.ccf_', ''));
                        _.each(this.contact.get('companyCustomFieldValues'), function (customField) {
                            if (customField.id === fieldId) {
                                field.fieldValue = customField.value;
                            }
                        });
                    }
                } else if (field.coreFieldName.indexOf('Contact.cf_') !== -1) {
                    if (this.contact != null) {
                        let fieldId = parseInt(field.coreFieldName.replace('Contact.cf_', ''));
                        _.each(this.contact.get('contactCustomFieldValues'), function (customField) {
                            if (customField.id === fieldId) {
                                field.fieldValue = customField.value;
                            }
                        });
                    }
                } else if (field.coreFieldName.toLowerCase() === 'isunion|isnonunion') {
                    let tempVal = [];
                    if (this.contact != null) {
                        if (this.contact.get('isUnion')) {
                            tempVal.push('Union');
                        }
                        if (this.contact.get('isNonUnion')) {
                            tempVal.push('Non-Union');
                        }
                    }
                    field.fieldValue = tempVal;
                } else if (field.coreFieldName.indexOf('Contact.') > -1) {
                    field.fieldValue = this.contact.get(PJQ.helpers.formatHelpers.lowerCaseFirstLetter(field.coreFieldName.replace('Contact.', '')));
                } else {
                    field.fieldValue = this.get(PJQ.helpers.formatHelpers.lowerCaseFirstLetter(field.coreFieldName));
                }
            } else if (field.fieldNumber > 0) {
                let tempVal = this.get('customFieldValues')[field.fieldNumber];
                if (typeof tempVal === 'string') {
                    switch (field.fieldType.toLowerCase()) {
                        case 'bool':
                            if (tempVal.toLowerCase() === 'true') {
                                tempVal = true;
                            } else if (tempVal.toLowerCase() === 'false') {
                                tempVal = false;
                            } else {
                                tempVal = null;
                            }
                            break;
                        case 'int':
                            let tryParse = parseInt(tempVal);
                            if (!isNaN(tryParse)) {
                                tempVal = tryParse;
                            }
                            break;
                        case 'choice':
                            if (tempVal.indexOf('|') !== -1) {
                                let choiceIds = [];
                                _.each(tempVal.split('|'), function (choiceVal) {
                                    let tryParse = parseInt(choiceVal);
                                    if (!isNaN(tryParse)) {
                                        choiceIds.push(tryParse);
                                    }
                                })
                                tempVal = choiceIds;
                            } else {
                                let tryParse = parseInt(tempVal);
                                if (!isNaN(tryParse)) {
                                    tempVal = tryParse;
                                } else {
                                    tempVal = null;
                                }
                            }
                            break;
                    }
                }
                field.fieldValue = tempVal;
            }
        }, this);
    },
    parse: function (model) {
        if (model && _.size(model) > 0) {
            if (this.contact && model.contact != null) {
                this.contact.set(model.contact);
                this.contact.parse(model.contact);
            } else {
                if (model.contact) {
                    if (model.contact instanceof PJQ.models.contacts.Contact)
                        this.contact = model.contact;
                    else
                        this.contact = new PJQ.models.contacts.Contact(model.contact);
                } else {
                    this.contact = new PJQ.models.contacts.Contact();
                }
            }

            this.comments = new PJQ.collections.prequal.Comments(model.comments);

            if (this.estimatingContacts) {
                this.estimatingContacts.reset(model.estimatingContacts);
            } else {
                this.estimatingContacts = new PJQ.collections.prequal.EstimatingContacts(model.estimatingContacts);
            }
            _.each(this.estimatingContacts.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.operationsContacts) {
                this.operationsContacts.reset(model.operationsContacts);
            } else {
                this.operationsContacts = new PJQ.collections.prequal.OperationsContacts(model.operationsContacts);
            }
            _.each(this.operationsContacts.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.ownerContacts) {
                this.ownerContacts.reset(model.ownerContacts);
            } else {
                this.ownerContacts = new PJQ.collections.prequal.OwnerContacts(model.ownerContacts);
            }
            _.each(this.ownerContacts.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.safetyContacts) {
                this.safetyContacts.reset(model.safetyContacts);
            } else {
                this.safetyContacts = new PJQ.collections.prequal.SafetyContacts(model.safetyContacts);
            }
            _.each(this.safetyContacts.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.otherOffices) {
                this.otherOffices.reset(model.otherOffices);
            } else {
                this.otherOffices = new PJQ.collections.prequal.OtherOffices(model.otherOffices);
            }
            _.each(this.otherOffices.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);

            if (this.projectReferences) {
                this.projectReferences.reset(model.projectReferences);
            } else {
                this.projectReferences = new PJQ.collections.prequal.ProjectReferences(model.projectReferences);
            }
            _.each(this.projectReferences.models, function (mod) {
                mod.set('contactId', this.contact.id);
            }, this);
        }
        return model;
    },
    sign: function (signature, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'prequal',
                    value: this.id
                },
                {
                    endpoint: 'sign'
                }
            ], [
                {
                    parameter: 'masterUserId',
                    value: this.get('masterUserId')
                }
            ]),
            data: {
                signature: signature
            }
        }).put().done(_.bind(function (res) {
            if (res.isLocked) {
                this.set('isLocked', res.isLocked);
            }
            this.set('signedOn', new Date(), {silent: true});
            callback(true);
        }, this));
    },
    updateLocked: function (isLocked, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'prequal',
                    value: this.id
                },
                {
                    endpoint: 'lock'
                }
            ], [
                {
                    parameter: 'isLocked',
                    value: isLocked
                }
            ])
        }).put().done(_.bind(function () {
            this.set('isLocked', isLocked);
            callback(true);
        }, this));
    },
    updateCompletion: function () {
        if (this.id > 0) {
            this.calculateCompletion();
            this.patch({
                percentComplete: this.get('percentComplete'),
                masterUserId: this.get('masterUserId')
            });
        }
    },
    calculateCompletion: function (isAdmin = false) {
        if (this.completionData == null) {
            this.completionData = {
                tabs: {},
                progress: 0
            };
        }
        _.each(this.tabs, _.bind(function (tabObj) {
            if (this.completionData.tabs[tabObj.prequalTabId] == null) {
                this.completionData.tabs[tabObj.prequalTabId] = {
                    fields: {},
                    tab: tabObj,
                    progress: 0,
                    isCalculate: tabObj.isCalculate
                }
            }
            let completionTab = this.completionData.tabs[tabObj.prequalTabId];
            _.each(tabObj.fields, (field) => {
                if (!field.isHidden && field.isRequired) {
                    if (!this.checkConstraintsMet(field)) {
                        completionTab.fields = _.omit(completionTab.fields, function (omitField) {
                            return omitField.field.prequalFieldId === field.prequalFieldId;
                        });
                    } else {
                        completionTab.fields[field.prequalFieldId] = {
                            field: field,
                            isValid: this.validateField(tabObj, field),
                            isAdmin: field.isAdmin
                        };
                    }
                }
            });

            let fieldCount = _.size(completionTab.fields),
                externalFieldCount = _.size(_.where(completionTab.fields, {
                    isAdmin: false
                }));
            if (fieldCount === 0) {
                completionTab.progress = 100;
                completionTab.saveProgress = 100;
            } else {
                if (externalFieldCount === 0) {
                    completionTab.saveProgress = 100;
                } else {
                    completionTab.saveProgress = Math.floor((_.size(_.where(completionTab.fields, {
                        isValid: true,
                        isAdmin: false
                    })) / externalFieldCount) * 100);
                }

                if (isAdmin) {
                    completionTab.progress = Math.floor((_.size(_.where(completionTab.fields, {
                        isValid: true
                    })) / fieldCount) * 100);
                } else {
                    completionTab.progress = completionTab.saveProgress;
                }
            }
        }, this));

        let fullTotal = 0,
            saveTotal = 0,
            calcTabCount = 0;
        _.each(this.completionData.tabs, function (tab) {
            if (tab.isCalculate !== false) {
                saveTotal += tab.saveProgress;
                calcTabCount++;
            }
            fullTotal += this.options.isAdmin ? tab.progress : tab.saveProgress;
        }, this);
        this.completionData.saveProgress = Math.floor(saveTotal / calcTabCount);
        this.completionData.progress = Math.floor(fullTotal / _.size(this.completionData.tabs));

        let completion = {
            percentComplete: this.completionData.saveProgress,
            totalComplete: this.completionData.progress,
            completionData: this.getCompletionData()
        };
        this.set(completion);
        return completion;
    },
    getCompletionData: function () {
        return {
            tabs: _.map(this.completionData.tabs, (calc) => {
                return {
                    id: calc.tab.prequalTabId,
                    progress: calc.progress
                };
            })
        };
    },
    checkConstraintsMet: function (field) {
        let isConstraintsMet = true;
        _.each(_.where(field.constraints, {customFieldId: field.prequalFieldId}), _.bind(function (constraint) {
            let controllerField = this.fields[constraint.controlledByCustomFieldId];
            if (controllerField == null)
                return;
            // else if (!this.checkConstraintsMet(controllerField)) {
            //     isConstraintsMet = false;
            //     return;
            // }
            switch (controllerField.fieldType.toLowerCase()) {
                case 'int':
                case 'money':
                case 'percent':
                    if (parseInt(constraint.constraintInfo) !== controllerField.fieldValue)
                        isConstraintsMet = false;
                    break;
                case 'text':
                case 'textarea':
                case 'phone':
                case 'date':
                    if (constraint.constraintInfo !== controllerField.fieldValue)
                        isConstraintsMet = false;
                    break;
                case 'choice':
                    let type = PJQ.helpers.objectHelpers.refinedType(controllerField.fieldValue);
                    if (_.find(constraint.constraintInfo.split('|'), function (choiceId) {
                        return controllerField.fieldValue != null && ((type === 'number' && controllerField.fieldValue === parseInt(choiceId)) || (type === 'array' && (controllerField.fieldValue.indexOf(parseInt(choiceId)) > -1 || controllerField.fieldValue.indexOf(choiceId) > -1)) || (type === 'object' && controllerField.fieldValue[parseInt(choiceId)] != null));
                    }) == null)
                        isConstraintsMet = false;
                    break;
                case 'bool':
                    if (constraint.constraintInfo != null) {
                        let cLower = constraint.constraintInfo.toString().toLowerCase();
                        if (cLower === '!true') {
                            if (controllerField.fieldValue === true) {
                                isConstraintsMet = false;
                            }
                        } else if (((constraint.constraintInfo === 'true' || constraint.constraintInfo === true) !== controllerField.fieldValue))
                            isConstraintsMet = false;
                    }

                    break;
            }
        }, this));
        return isConstraintsMet;
    },
    validateField: function (tab, field) {
        if (!field.isRequired)
            return true;

        let isValid = false;
        switch (field.fieldType.toLowerCase()) {
            case 'upload':
                isValid = field.fieldValue != null && _.size(field.fieldValue) > 0;
                break;
            case 'int':
            case 'money':
            case 'percent':
                isValid = field.fieldValue != null && !isNaN(parseFloat(field.fieldValue));
                break;
            case 'choice':
                isValid = field.fieldValue != null && ((!isNaN(field.fieldValue) && field.fieldValue > 0) || _.size(field.fieldValue) > 0);
                break;
            case 'text':
            case 'textarea':
            case 'phone':
            case 'date':
            case 'state':
                isValid = field.fieldValue != null && field.fieldValue.length > 0;
                break;
            case 'bool':
                isValid = (field.fieldValue === true || field.fieldValue === false);
                break;
            case 'grid':
                if (field.coreFieldName.toLowerCase() === 'otheroffices') {
                    isValid = _.size(_.filter(this.otherOffices ? this.otherOffices.models : [], _.bind(function (office) {
                        let isCityValid = office.get('city').length > 0,
                            isStateValid = office.get('stateProvince').length > 0,
                            isZipValid = office.get('postalCode').length > 0;
                        return isCityValid && isStateValid && isZipValid;
                    }, this))) >= 1;
                } else if (field.coreFieldName.toLowerCase() === 'ownercontacts' || field.coreFieldName.toLowerCase() === 'operationscontacts' || field.coreFieldName.toLowerCase() === 'estimatingcontacts' || field.coreFieldName.toLowerCase() === 'safetycontacts') {
                    let contacts;
                    if (field.coreFieldName.toLowerCase() === 'ownercontacts') {
                        contacts = this.ownerContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'operationscontacts') {
                        contacts = this.operationsContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'estimatingcontacts') {
                        contacts = this.estimatingContacts;
                    } else if (field.coreFieldName.toLowerCase() === 'safetycontacts') {
                        contacts = this.safetyContacts;
                    }
                    isValid = _.size(_.filter(contacts ? contacts.models : [], _.bind(function (contact) {
                        let isContactNameValid = contact.get('contactName').length > 0,
                            isEmailValid = contact.get('email').length > 0,
                            isPhoneValid = contact.get('phone').length > 0;
                        if (field.coreFieldName.toLowerCase() === 'ownercontacts') {
                            let isTitleValid = contact.get('contactTitle').length > 0;
                            return isContactNameValid && isEmailValid && isPhoneValid && isTitleValid;
                        } else {
                            return isContactNameValid && isEmailValid && isPhoneValid;
                        }
                    }, this))) >= 1;
                } else if (field.coreFieldName.toLowerCase() === 'projectreferences') {
                    isValid = _.size(_.filter(this.projectReferences ? this.projectReferences.models : [], function (reference) {
                        return reference.checkIsRecent();
                    })) >= 3;

                    isValid = _.size(_.filter(this.projectReferences.models ? this.projectReferences.models : [], _.bind(function (reference) {
                        if (!reference.checkIsRecent())
                            return false;

                        let isGCValid = reference.get('generalContractor').length > 0,
                            isGCContactValid = reference.get('generalContractorContactName').length > 0,
                            isGCPhoneValid = reference.get('generalContractorContactPhone').length > 0,
                            isProjectNameValid = reference.get('projectName').length > 0,
                            isDateCompletedValid = reference.get('dateCompleted') !== null,
                            isContractValueValid = reference.get('contractValue') > 0;
                        return isGCValid && isGCContactValid && isGCPhoneValid && isProjectNameValid && isDateCompletedValid && isContractValueValid;
                    }, this))) >= 3;
                }
                break;
            case 'groupselect':
                isValid = _.find(this.contact.groups.models, function (model) {
                    return model.get('isDeleted') !== true
                }) != null;
                break;
            case 'regionselect':
                isValid = this.contact.workAreas != null && _.size(this.contact.workAreas.models) > 0;
                break;
        }
        return isValid;
    },
    getAllPrequalContacts: function () {
        return _.union(this.operationsContacts.models, this.estimatingContacts.models, this.safetyContacts.models)
    }
});

PJQ.models.prequal.OtherOffice = PJQ.models.BaseModel.extend({
    idAttribute: "officeId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'offices',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.OwnerContact = PJQ.models.BaseModel.extend({
    idAttribute: "ownerContactId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'ownercontacts',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.OperationsContact = PJQ.models.BaseModel.extend({
    idAttribute: "operationsContactId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'operationscontacts',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.EstimatingContact = PJQ.models.BaseModel.extend({
    idAttribute: "estimatingContactId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'estimatingcontacts',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.SafetyContact = PJQ.models.BaseModel.extend({
    idAttribute: "safetyContactId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'safetycontacts',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.ProjectReference = PJQ.models.BaseModel.extend({
    idAttribute: "projectReferenceId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'contacts',
                value: this.get('contactId') != null ? this.get('contactId') : this.get('contactCompanyId')
            },
            {
                endpoint: 'projectreferences',
                value: this.id
            }
        ]);
    },
    parse: function (model) {
        model = model ? model : {};

        model.theme = _.defaults(model && model.theme ? model.theme : {}, this.defaultTheme);

        if (this.photos) {
            this.photos.reset(model.photos);
        } else {
            this.photos = new PJQ.collections.prequal.ProjectReferencePhotos(model.photos);
        }

        return model;
    },
    checkIsRecent: function () {
        let createdOn = this.get('createdOn');
        return PJQ.helpers.dateHelpers.getDateMillisecondsDiff(new Date(), createdOn ? new Date(createdOn) : new Date()) < PJQ.constants.time.millis.ONE_YEAR
    }
});

PJQ.models.prequal.ProjectReferencePhoto = PJQ.models.BaseModel.extend({
    idAttribute: 'projectReferencePhotoId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projectreferences',
                value: this.get('projectReferenceId')
            },
            {
                endpoint: 'photos',
                value: this.id
            }
        ]);
    }
});

PJQ.models.prequal.Comment = PJQ.models.BaseModel.extend({
    idAttribute: "commentId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'companies',
                value: this.get('contactCompanyId')
            },
            {
                endpoint: 'prequal'
            },
            {
                endpoint: 'comments',
                value: this.id
            }
        ], [
            {
                parameter: 'masterUserId',
                value: this.get('masterUserId')
            }
        ])
    },
    parse: function (model) {
        if (!model) {
            return model;
        }

        if (model.createdBy != null) {
            this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
        }

        return model;
    }
});

PJQ.models.prequal.AuditLog = PJQ.models.BaseModel.extend({
    idAttribute: 'prequalAuditLogId',
    getValue: function (fieldValue, fieldType) {
        switch (fieldType.toLowerCase()) {
            case 'bool':
                switch (fieldValue) {
                    case '':
                        return '';
                    case '0':
                    case 'false':
                        return 'No';
                    case '1':
                    case 'true':
                        return 'Yes';
                }
                break;
            case 'money':
                if (fieldValue != null)
                    return PJQ.helpers.formatHelpers.formatCurrency(fieldValue);
                break;
            case 'percent':
                if (fieldValue != null)
                    return PJQ.helpers.formatHelpers.formatPercent(fieldValue);
                break;
        }

        return fieldValue;
    }
});

//Collections
PJQ.collections.prequal = {};

PJQ.collections.prequal.OtherOffices = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.OtherOffice
});

PJQ.collections.prequal.OwnerContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.OwnerContact
});

PJQ.collections.prequal.OperationsContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.OperationsContact
});

PJQ.collections.prequal.EstimatingContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.EstimatingContact
});

PJQ.collections.prequal.SafetyContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.SafetyContact
});

PJQ.collections.prequal.EstimatingContacts = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.EstimatingContact
});

PJQ.collections.prequal.ProjectReferences = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.ProjectReference
});

PJQ.collections.prequal.ProjectReferencePhotos = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.ProjectReferencePhoto,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projectreferences',
                value: this.id
            },
            {
                endpoint: 'photos'
            }
        ]);
    }
});

PJQ.collections.prequal.Comments = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.Comment
});

PJQ.collections.prequal.PrequalAuditLog = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.prequal.AuditLog,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'contacts',
                    value: this.options.contactId
                },
                {
                    endpoint: 'prequal'
                },
                {
                    endpoint: 'auditlog'
                }
            ]
        );
    }
});